import { type HttpClient } from '../useHttpClient';

type PatchOperatorsParams = {
  userIds: string[];
  isOperator: boolean;
};

export const patchOperators =
  (httpClient: HttpClient) =>
  async (channelUrl: string, params: PatchOperatorsParams) => {
    const userIds = params.userIds.map((id) => Number(id));

    await httpClient.api(`/sendbird/channels/${channelUrl}/operators`, {
      method: 'PATCH',
      body: JSON.stringify({
        userIds,
        isOperator: params.isOperator,
      }),
    });
  };
